import { TIMSCRIBE_ENABLED } from "@/components/timscribe/shared";
export default function Footer({ onSafetyTrigger }) {
    return (
        <footer id="footer" className="bg-[#e2e8f0] py-16 border-t border-subtle" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 pb-12 border-b border-slate-200">
                    <div>
                        <div className="font-mono text-base font-bold text-slate-900 tracking-wider flex items-center gap-3">
                            <span className="h-2.5 w-2.5 bg-cyan-400 rounded-full animate-status" />
                            TIMBOTIC
                        </div>
                        <p className="text-slate-500 text-xs mt-2">
                            Independent Experimental Robotics &amp; Software &middot; Brisbane, Australia
                        </p>
                    </div>
                    <div className="font-mono text-xs text-slate-500">
                        SYSTEM STATUS: <span className="text-emerald-600">OPERATIONAL*</span>
                        <span className="block text-[10px] text-slate-600 mt-0.5">
                            *Definition of operational subject to change without notice.
                        </span>
                        <div className="mt-3 flex items-center gap-2">
                            <button
                                type="button"
                                onClick={onSafetyTrigger}
                                data-testid="safety-system-trigger"
                                className="text-[10px] tracking-widest text-slate-600 hover:text-red-600 transition-colors border border-slate-200 hover:border-red-500/40 rounded px-2 py-1"
                            >
                                TIMBOTIC SAFETY SYSTEM
                            </button>
                            <a
                                href="https://bot.timbotic.com"
                                rel="nofollow noopener noreferrer"
                                data-testid="operator-access-link"
                                className="text-[10px] tracking-widest text-slate-400 hover:text-cyan-600 transition-colors border border-transparent hover:border-cyan-500/40 rounded px-2 py-1"
                                title="Operator access"
                            >
                                ··
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 font-mono text-xs text-slate-500">
                    <div>Copyright &copy; 2026 Timbotic.</div>
                    {TIMSCRIBE_ENABLED && (
                        <a href="/timscribe" data-testid="footer-timscribe-link" className="text-slate-500 hover:text-cyan-700 transition-colors tracking-widest text-[11px]">
                            TIMSCRIBE — FREE OFFLINE DICTATION FOR WINDOWS &rarr;
                        </a>
                    )}
                    <div className="text-cyan-600/80 text-[11px]">
                        Please do not give Timbot access to anything important.
                    </div>
                </div>
            </div>
        </footer>
    );
}
